export function isElementVisible(element, callback) {
  const position = element.getBoundingClientRect()
  const parentWidth = window.innerWidth || document.documentElement.clientWidth
  const parentHeight = window.innerHeight || document.documentElement.clientHeight
  const fullyVisible = position.top >= 0 && position.bottom <= parentHeight
  const partiallyVisible = position.top < parentHeight && position.bottom >= 0

  if (typeof callback === 'function') {
    if (partiallyVisible || fullyVisible) {
      callback({partiallyVisible, fullyVisible})
    }
  }

  return {
    /**
     * attach events
     * @param [events]
     */
    attachEvents: function (events) {
      attachEvents(events, function () {
        isElementVisible(element, callback)
      })
    },
    attachDefaultEvents: function () {
      attachEvents('scroll resize', function () {
        isElementVisible(element, callback)
      })
    }
  }
}

function attachEvents(events, callback) {
  if (typeof events === 'string' && events) {
    events.split(' ').forEach(event => {
      window.addEventListener(event, function () {
        callback()
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/useElementVisible.js